export const PARTNER_ID = 'RiskPartners';
export const PARTNER_DISPLAY_NAME = 'RiskPartners';
export const SUPPORT_EMAIL = 'support@cleoapp.uk';
export const PRODUCT_NAME = 'CyberCheck';

export const AUTH_CONFIG = {
  ENTRA_CLIENT_ID: '6d1c8497-25ec-4d01-997d-9cf1560e20f6',
  DEFENDER_CLIENT_ID: '54e0cc26-2571-40f7-ba3f-24277cff7cd1',
  AZURE_CLIENT_ID: '65580dd9-b84d-4b3f-a845-5d7985c2ff40',
} as const;

export const COGNITO_CONFIG = {
  CLIENT_ID: '63njivtgsgji320ral869utaq5',
  USER_POOL_ID: 'eu-west-2_9NN3lz5Iq',
  REGION: 'eu-west-2',
  DOMAIN: 'sso.quickcheck.strata-host.co.uk',
  PARTNER_ADMIN_GROUP: 'partner_admin',
  IDENTITY_POOL_ID: 'eu-west-2:c8c5d69c-a987-4fea-89e8-07bad75cecd6'
} as const;

export const S3_CONFIG = {
  BUCKET_NAME: 'cleo-quickcheck-reports',
  REGION: 'eu-west-2'
} as const;
